
<template>
  <div>
    <Header/>
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Produkte</v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <p>
                      Verwalten Sie ihre angelegten Produkte.
                    </p>
                    <a href="products/add"><v-btn class="primary" style="position: absolute; right: 40px">Neues Produkt <v-icon>mdi-plus</v-icon></v-btn></a>
                  </v-row>
                  <v-row>
                    <v-product
                      v-for="product in products"
                      v-bind:key="products.indexOf(product)"
                      v-bind:id="products.indexOf(product)"
                      v-bind:title="product.name"
                      v-bind:src="'https://acs.accelery.de/api/assets/'+ product.imageId"
                      v-bind:description="product.description"
                      v-bind:price="product.engravingPrice"
                      v-bind:stock="product.stock"
                      v-bind:live="product.published == 1"
                      v-bind:acdPrice="product.acdPrice"
                      @click.native="editProduct(product.id)"
                    ></v-product>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Header from "@/views/general/header";
import router from "@/plugins/router";
import ProductCard from "@/components/ProductTile";
import productService from "@/services/ProductService"
export default {
  name: "dashboard",
  components: {
    Header: Header,
    "v-product": ProductCard
  },
  data: () => ({
    loading: true,
    products: null,
    error: null
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      try {
        this.products = (await productService.get(this.$route.params.id)).data;
        this.loading = false;
      } catch (err) {
        this.error = err.message;
      }
    },
  
    editProduct(id) {
      router.push({ name: 'editProduct', params: { id: this.$route.params.id, productId: id } })
    },

    openCategories() {
      router.push({ name: 'categories', params: { id: this.$route.params.id } })
    }
  }
};
</script>

